/* eslint no-useless-escape: 0 */

'use strict';

export default {
  methods: {
    getCanales (filter) {
      this.$service.graphql({
        query: `
          query getCanales {
            canales(order: "clasificacion") {
              count
              rows {
                id
                clasificacion
                usuario
              }
            }
          }
        `,
        variables: {
          estado: 'ACTIVO'
        }
      }).then(response => {
        if (response) {
          let items = response.canales.rows;
          let canales = [];
          items.map(canal => {
            canales.push({ value: canal.id, text: (canal.clasificacion + '').replace(/_/gi, ' ') + ' - ' + canal.usuario });
          });
          this.canales = canales;
          if ((filter || filter === 0) && this.filters[filter] && this.filters[filter].items) {
            this.filters[filter].items = this.canales;
          }
        }
      });
    },
    getOperadores (filter) {
      this.$service.graphql({
        query: `
          query getOperadores {
            operadores(order: "nombre_completo") {
              count
              rows {
                id
                nombre_completo
              }
            }
          }
        `,
        variables: {
          estado: 'ACTIVO'
        }
      }).then(response => {
        if (response) {
          let items = response.operadores.rows;
          let operadores = [];
          items.map(op => {
            operadores.push({ value: op.id, text: op.nombre_completo });
          });
          this.operadores = operadores;
          if ((filter || filter === 0) && this.filters[filter] && this.filters[filter].items) {
            this.filters[filter].items = this.operadores;
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/admin/puntos_atencion/mixins/puntoAtencion.js